<div class="" #selectionButton>
  @if (
    radarSelection
      ? radarSelection == 'multiple'
      : gridConf.selectionMode == 'multiple'
  ) {
    <button
      mat-button
      mat-stroked-button
      (click)="showSelected()"
      [disabled]="!selectedRowsVisible && !selectedRowsData.length"
      style="margin: 8px"
    >
      {{
        (!selectedRowsVisible ? 'Visualizza selezionati' : 'Visualizza tutto')
          | siaTranslate
      }}
    </button>
  }
</div>
<dx-data-grid
  #grid
  [id]="elementId"
  [showBorders]="gridConf.showBorders ?? false"
  [rowAlternationEnabled]="gridConf.rowAlternationEnabled ?? false"
  [hoverStateEnabled]="gridConf.hoverStateEnabled ?? false"
  [showColumnLines]="gridConf.showColumnLines ?? false"
  [allowColumnReordering]="gridConf.allowColumnReordering ?? false"
  [allowColumnResizing]="gridConf.allowColumnResizing ?? false"
  [columnHidingEnabled]="gridConf.columnHidingEnabled ?? false"
  [columnResizingMode]="
    getGridConfResizingMode(gridConf.columnResizingMode ?? '')
  "
  [columnAutoWidth]="false"
  [columnMinWidth]="+(gridConf.columnMinWidth ?? '0')"
  [showRowLines]="gridConf.showRowLines ?? false"
  [filterSyncEnabled]="true"
  [errorRowEnabled]="false"
  [focusedRowEnabled]="false"
  [elementAttr]="{ class: 'sia-grid' }"
  [height]="
    gridHeight && gridHeight > 0
      ? gridHeight -
        (gridFooterElement?.nativeElement?.offsetHeight ?? 0) -
        (selectionButton?.offsetHeight ?? 0)
      : 'calc(100% - ' +
        gridFooterElement?.nativeElement?.offsetHeight +
        'px - ' +
        selectionButton?.offsetHeight +
        'px)'
  "
  (onSaved)="saved($event)"
  (onExporting)="exportDatagrid($event)"
  (onExported)="restoreColumns([])"
  (onRowPrepared)="rowPrepared($event)"
  (onCellPrepared)="cellPrepared($event)"
  (onSelectionChanged)="selectionChanged($event)"
  (onRowInserted)="rowInserted($event)"
  (onRowUpdated)="rowUpdated($event)"
  (onRowDeleted)="rowDeleted($event)"
  (onToolbarPreparing)="hideButtons($event)"
  (onEditorPreparing)="onEditorPreparing($event)"
  (filterValueChange)="onFilterValueChange($event)"
  (onContentReady)="applySelection()"
>
  @for (column of columns; track trackById($index, column)) {
    <dxi-column
      [id]="column.id"
      [groupIndex]="column.groupIndex"
      [name]="column.name"
      [dataField]="column.dataField"
      [dataType]="column.dataType"
      [width]="column.width"
      [caption]="column.caption"
      [allowEditing]="column.allowEditing"
      [hidingPriority]="column.hidingPriority"
      [visible]="column.visible"
      [format]="column.format"
      [alignment]="column.alignment"
      [allowSorting]="column.allowSorting"
      [(sortOrder)]="column.sortOrder"
      [(sortIndex)]="column.sortIndex"
      [showInColumnChooser]="column.showInColumnChooser"
      [allowHiding]="column.allowHiding"
      cellTemplate="Template"
      [allowExporting]="column.allowExporting"
      [groupIndex]="column.groupIndex"
      [selectedFilterOperation]="column.selectedFilterOperation"
      [visibleIndex]="column.visibleIndex"
    >
      <dxo-header-filter [dataSource]="column.headerFilterDataSource">
      </dxo-header-filter>
    </dxi-column>
  }

  <dxo-selection
    [mode]="radarSelection ? radarSelection : (gridConf.selectionMode ?? '')"
    [allowSelectAll]="true"
    selectAllMode="allPages"
    [showCheckBoxesMode]="'always'"
  >
  </dxo-selection>
  <dxo-grouping #expand [autoExpandAll]="autoExpand"> </dxo-grouping>
  <dxo-paging [(pageSize)]="pageSize"> </dxo-paging>
  <dxo-pager [visible]="false"> </dxo-pager>
  <dxo-header-filter [visible]="true"> </dxo-header-filter>
  <dxo-search-panel [searchVisibleColumnsOnly]="true"> </dxo-search-panel>
  <ng-container *dxTemplate="let data of 'titleHeaderTemplate'">
    {{ data.column.caption }}
  </ng-container>
  <div
    *dxTemplate="let data of 'Template'"
    (click)="manageCellClick(data)"
    [style]="getTemplateStyle(data)"
  >
    @switch (getTemplateType(data)) {
      @case ('Default') {
        <span [style]="data.column.isFullText ? fullTextStyle : ''">
          {{ getDefaultFormattedValue(data) }}
        </span>
      }
      @case ('ColorEdit') {
        <dx-color-box
          [disabled]="false"
          [(value)]="data.value"
          applyValueMode="instantly"
          (onValueChanged)="valueChange($event, data)"
        >
        </dx-color-box>
      }
      @case ('Color') {
        <dx-color-box
          [disabled]="true"
          [(value)]="data.value"
          applyValueMode="instantly"
        >
        </dx-color-box>
      }
      @case ('AvatarBig') {
        <sia-cell-avatar
          [width]="data.column.iconWidth ?? 64"
          [userId]="data.value"
        >
        </sia-cell-avatar>
      }
      @case ('AvatarSmall') {
        <sia-cell-avatar
          [width]="data.column.iconWidth ?? 32"
          [userId]="data.value"
        >
        </sia-cell-avatar>
      }
      @case ('ImageSmall') {
        <img [width]="data.column.iconWidth ?? 32" [src]="data.value" />
      }
      @case ('IconAndDescription') {
        <i [class]="data.value"> </i> &nbsp; {{ data.value }}
      }
      @case ('Icon') {
        <i
          [class]="data.value"
          [style]="'width:' + (data.column.iconWidth ?? 32) + 'px'"
        >
        </i>
      }
      @case ('IconMaterial') {
        <span
          class="material-symbols-outlined"
          [style]="'width:' + (data.column.iconWidth ?? 32) + 'px'"
        >
          {{ data.value }}
        </span>
      }
      @case ('IconAndDescriptionEdit') {
        <dx-text-box
          [(value)]="data.value"
          valueChangeEvent="keyup"
          [style]="'width:' + (data.column.iconWidth ?? 32) + 'px'"
          (onValueChanged)="valueChange($event, data)"
        >
        </dx-text-box>
      }
      @case ('DownloadLink') {
        <p
          class="p-link"
          (click)="onDownloadClick(data)"
          [style]="data.column.isFullText ? fullTextStyle : ''"
        >
          {{ data.value }}
        </p>
      }
      @case ('RouterLink') {
        <span
          class="link-like"
          [style]="data.column.isFullText ? fullTextStyle : ''"
          (click)="onRouteClick(data)"
        >
          {{ getRouterValue(data) }}
        </span>
      }
      @case ('RouterLinkExternal') {
        <span
          (click)="onRouteClick(data)"
          class="link-like"
          [style]="data.column.isFullText ? fullTextStyle : ''"
        >
          {{ getRouterValue(data) }}
        </span>
      }
      @case ('RouterLinkJsonConfig') {
        <span
          class="link-like"
          (click)="onRouteClickJsonConfig(data)"
          [style]="data.column.isFullText ? fullTextStyle : ''"
        >
          {{ getRouterValue(data) }}
        </span>
      }
      @case ('CustomRouterLink') {
        <span
          class="link-like"
          (click)="onRouteClick(data)"
          [style]="data.column.isFullText ? fullTextStyle : ''"
        >
          {{ getRouterValue(data) }}
        </span>
      }
      @case ('FullText') {
        <span style="white-space: break-spaces">
          {{ data.value }}
        </span>
      }
      @case ('RouterIconLink') {
        <ng-container style="cursor: pointer">
          <i [class]="getRouterValue(data)" (click)="onRouteClick(data)"> </i>
        </ng-container>
      }
      @case ('RouterIconLinkMaterial') {
        <ng-container style="cursor: pointer; text-align: center">
          <span class="material-symbols-outlined" (click)="onRouteClick(data)">
            {{ data.value }}
          </span>
        </ng-container>
      }
      @case ('CustomRouterIconLink') {
        <ng-container style="cursor: pointer">
          <i [class]="getRouterValue(data)" (click)="onRouteClick(data)"> </i>
        </ng-container>
      }
      @case ('FileExtension') {
        <i [ngClass]="getFileIcon(data)"> </i>
      }
      @case ('Bool') {
        <dx-check-box
          [value]="data.value"
          [disabled]="true"
          style="opacity: 0.8"
        >
        </dx-check-box>
      }
      @case ('Char2Bool') {
        <dx-check-box [value]="data.value == 'S'" [disabled]="true">
        </dx-check-box>
      }
      @case ('Char2BoolEdit') {
        <dx-check-box
          [value]="data.value == 'S'"
          (onValueChanged)="char2BoolChange(data)"
        >
        </dx-check-box>
      }
      @case ('Int2Date') {
        <dx-date-box
          [value]="number2date(data.value)"
          [disabled]="true"
          id="gridDateBox"
        >
        </dx-date-box>
      }
      @case ('Int2DateEdit') {
        <dx-date-box
          pickerType="rollers"
          [value]="number2date(data.value)"
          [showClearButton]="true"
          [min]="getDate()"
          (onValueChanged)="date2Number($event, data)"
        >
        </dx-date-box>
      }
      <!-- TEMPLATE ACTION EMIT KEY -->
      @case ('ActionGeneric') {
        @if (
          data['__actionVisible'] != undefined
            ? data['__actionVisible']
            : (visibilityCheck(data) | async)
        ) {
          <div
            class="action-button"
            mat-button
            (click)="onGenericClickAction(data)"
          >
            <span class="material-icons">
              {{ data.column.icon }}
            </span>
            <span> {{ getText(data) }} </span>
          </div>
        }
      }
      @case ('ReportLink') {
        @if (visibilityReportCheck(data)) {
          <div
            class="action-button"
            mat-button
            (click)="onReportLinkClickAction(data)"
          >
            <span class="material-icons">
              {{ data.column.icon }}
            </span>
            <span> {{ getText(data) }} </span>
          </div>
        }
      }
      @case ('ActionPK') {
        @if (
          data['__actionVisible'] != undefined
            ? data['__actionVisible']
            : (visibilityCheck(data) | async)
        ) {
          <div
            class="action-button"
            mat-button
            (click)="emitGridKey(data, data.column.id)"
          >
            <span class="material-icons">
              {{ data.column.icon }}
            </span>
            <span> {{ getText(data) }} </span>
          </div>
        }
      }
      @case ('ActionDownload') {
        @if (checkDownloadVisibility(data)) {
          <div
            class="action-button"
            mat-button
            (click)="onDownloadClickAction(data)"
          >
            <span class="material-symbols-outlined">
              {{ data.column.icon }}
            </span>
            <span> {{ getText(data) }} </span>
          </div>
        }
      }
      @case ('ActionLink') {
        <ng-container style="text-align: center">
          @if (
            data['__actionVisible'] != undefined
              ? data['__actionVisible']
              : (visibilityCheck(data) | async)
          ) {
            <div
              class="action-button"
              mat-button
              (click)="onRouteClickAction(data)"
            >
              <span class="material-icons">
                {{ data.column.icon }}
              </span>
              <span> {{ getText(data) }} </span>
            </div>
          }
        </ng-container>
      }
      @case ('ActionLinkMaterial') {
        <ng-container style="text-align: center">
          @if (
            data['__actionVisible'] != undefined
              ? data['__actionVisible']
              : (visibilityCheck(data) | async)
          ) {
            <div
              class="action-button"
              style="padding: 0px; cursor: pointer"
              mat-button
              (click)="onRouteClickAction(data)"
            >
              <span
                class="material-symbols-outlined"
                style="text-align: center; vertical-align: middle"
              >
                {{ getIcon(data) }}
              </span>
              <span> {{ getText(data) }} </span>
            </div>
          }
        </ng-container>
      }
      @case ('ActionMaterial') {
        <ng-container style="text-align: center">
          @if (
            data['__actionVisible'] != undefined
              ? data['__actionVisible']
              : (visibilityCheck(data) | async)
          ) {
            <div
              class="action-button"
              style="padding: 0px; cursor: pointer"
              mat-button
              (click)="manageCellClick(data)"
            >
              <span
                class="material-symbols-outlined"
                style="text-align: center; vertical-align: middle"
              >
                {{ getIcon(data) }}
              </span>
              <span> {{ getText(data) }} </span>
            </div>
          }
        </ng-container>
      }
      <!-- TEMPLATE POS NEG  -->
      @case ('PosNeg') {
        <span style="text-align: right" [ngClass]="getPosNegClass(data.value)">
          {{ data.text }}
        </span>
      }
      <!-- TEMPLATE EMAIL -->
      @case ('EmailLink') {
        <a [href]="'mailto:' + data.value"> {{ data.value }} </a>
      }
      <!-- TEMPLATE TELEFONO -->
      @case ('TelephoneLink') {
        <a [href]="'tel:' + data.value"> {{ data.value }} </a>
      }
    }
  </div>
</dx-data-grid>
<sia-grid-footer
  #gridFooter
  gridViewMode="standard"
  [pageCount]="getPageCount()"
  [(pageIndex)]="gridPageIndex"
  [(pageSize)]="gridPageSize"
  [totalCount]="getTotalCount()"
  [exportEnabled]="gridConf.exportEnabled ?? false"
  [(selectedAction)]="bulkAction"
  [allowUpdate]="gridConf.allowMassiveUpdate"
  [allowSelectIds]="
    _permissions.canUpdate
      ? gridConf.allowIdsSP
        ? (gridConf.idsSPActionName ?? '')
        : ''
      : ''
  "
  [allowDelete]="gridConf.allowMassiveDelete"
  [allowMerge]="gridConf.allowMerge"
  [allowComparison]="gridConf.allowComparison"
  (confirmAction)="processBulkAction()"
>
</sia-grid-footer>
@if (processIds) {
  <div class="sia-blur sia-flex-center">
    <mat-spinner></mat-spinner>
  </div>
}
